import { render, staticRenderFns } from "./QuestionIndex.vue?vue&type=template&id=cf04f978&scoped=true&"
import script from "./QuestionIndex.vue?vue&type=script&lang=ts&"
export * from "./QuestionIndex.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionIndex.vue?vue&type=style&index=0&id=cf04f978&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf04f978",
  null
  
)

export default component.exports